<template>
    <DropdownMenuTrigger class="group text-white">
        <slot />
        <i class="ml-1 inline-block fas fa-caret-down group-data-[state=open]:rotate-180"></i>
    </DropdownMenuTrigger>
</template>
